// B3SHARE deposit form overrides — registered via overridableRegistry/mapping.js
// Injects custom fields into existing InvenioRDM Overridable slots without
// modifying RDMDepositForm.js (future-upgrade-friendly).

import React from "react";
import { AccordionField } from "react-invenio-forms";
import Overridable from "react-overridable";
import { useFormikContext } from "formik";
import {
  LocationsField,
  InstrumentsField,
  ContactEmailsField,
  TemporalCoverageField,
} from "@js/invenio_rdm_records";
import { i18next } from "@translations/invenio_app_rdm/i18next";
import {
  ExternalRecordSearchModal,
  isInstrumentDuplicate,
  toB2ShareInstrument,
} from "@js/b3share/b2inst";

// Slot: InvenioAppRdm.Deposit.AccordionFieldBasicInformation.extra
// Receives overridableBlocksCommonProps (record, files, config, vocabularies, …)
export const BasicInformationExtraFields = () => (
  <ContactEmailsField fieldPath="metadata.contact_emails" showEmptyValue />
);

// Slot: InvenioAppRdm.Deposit.AccordionFieldRecommendedInformation.extra
// Receives overridableBlocksCommonProps
export const RecommendedInformationExtraFields = () => (
  <>
    <LocationsField
      fieldPath="metadata.locations.features"
      options={[
        { text: "Point", value: "Point" },
        { text: "MultiPoint", value: "MultiPoint" },
        { text: "Polygon", value: "Polygon" },
        { text: "Box", value: "Envelope" },
      ]}
      showEmptyValue
    />
    <TemporalCoverageField
      fieldPath="metadata.temporal_coverage"
      options={[
        { text: "Range", value: "ranges" },
        { text: "Span", value: "spans" },
      ]}
      showEmptyValue
    />
  </>
);

// Slot: InvenioAppRdm.Deposit.RecommendedInformation.after.container
// Receives overridableBlocksCommonProps — destructure vocabularies
export const InstrumentsAccordion = ({ vocabularies }) => {
  const { values, setFieldValue } = useFormikContext();
  const b2instEnabled =
    document.querySelector("input[name='b3share-b2inst-enabled']")?.value === "true";

  const handleAddInstrument = (instrument) => {
    const current = values?.metadata?.instruments || [];
    setFieldValue("metadata.instruments", [...current, instrument]);
  };

  return (
    <Overridable
      id="InvenioAppRdm.Deposit.AccordionFieldInstruments.container"
      vocabularies={vocabularies}
    >
      <AccordionField
        includesPaths={["metadata.instruments"]}
        active
        label={i18next.t("Instruments")}
      >
        <Overridable
          id="InvenioAppRdm.Deposit.InstrumentsField.container"
          vocabularies={vocabularies}
          fieldPath="metadata.instruments"
        >
          <InstrumentsField
            fieldPath="metadata.instruments"
            label={i18next.t("Instruments")}
            labelIcon="wrench"
            options={vocabularies?.metadata?.identifiers}
            showEmptyValue
          />
        </Overridable>

        {b2instEnabled && (
          <ExternalRecordSearchModal
            apiPrefix="/api/b2inst"
            buttonLabel={i18next.t("Search B2INST")}
            modalTitle={i18next.t("Search B2INST instruments")}
            openRecordLabel={i18next.t("Open in B2INST")}
            addRecordLabel={i18next.t("Add")}
            duplicateMessage={i18next.t(
              "This B2INST instrument is already included in the record."
            )}
            toItemObject={toB2ShareInstrument}
            isDuplicateItem={isInstrumentDuplicate}
            existingItems={values?.metadata?.instruments || []}
            onAddItem={handleAddInstrument}
          />
        )}
      </AccordionField>
    </Overridable>
  );
};
